// Heuristic "Potential Newbie Trap" detector — tokens whose name copies a big real brand
// to fool newcomers. This is a WARNING, not a verdict (a token could be a legit/official one).
const BRANDS = [
  ["nvidia", "NVIDIA", "nvda"], ["tesla", "Tesla", "tsla"], ["apple", "Apple", "aapl"],
  ["google", "Google", "googl"], ["amazon", "Amazon", "amzn"], ["microsoft", "Microsoft", "msft"],
  ["netflix", "Netflix", "nflx"], ["nike", "Nike", "nke"], ["adidas", "Adidas", ""],
  ["ferrari", "Ferrari", ""], ["lamborghini", "Lamborghini", ""], ["mcdonald", "McDonald's", ""],
  ["starbucks", "Starbucks", ""], ["coca[- ]?cola", "Coca-Cola", ""], ["pepsi", "Pepsi", ""],
  ["walmart", "Walmart", ""], ["spacex", "SpaceX", ""], ["openai", "OpenAI", ""],
  ["chatgpt", "ChatGPT", ""], ["paypal", "PayPal", "pypl"], ["visa", "Visa", ""],
  ["mastercard", "Mastercard", "ma"], ["samsung", "Samsung", ""], ["sony", "Sony", ""],
  ["playstation", "PlayStation", ""], ["nintendo", "Nintendo", ""], ["blackrock", "BlackRock", ""],
  ["jpmorgan", "JPMorgan", ""], ["gamestop", "GameStop", "gme"], ["robinhood", "Robinhood", "hood"],
  ["boeing", "Boeing", "ba"], ["ford", "Ford", "f"], ["toyota", "Toyota", ""],
  ["nasa", "NASA", ""], ["fedex", "FedEx", ""], ["uber", "Uber", ""], ["airbnb", "Airbnb", ""],
  ["disney", "Disney", ""], ["marvel", "Marvel", ""], ["spotify", "Spotify", ""],
];

export const newbieTrapBrand = (name = "", symbol = "") => {
  const nm = (name || "").toLowerCase();
  const sym = (symbol || "").toLowerCase();
  for (const [key, label, ticker] of BRANDS) {
    const re = new RegExp(`(^|[^a-z])${key}([^a-z]|$)`, "i");
    if (re.test(nm) || sym === key.replace(/[^a-z]/g, "") || (ticker && sym === ticker)) {
      return label;
    }
  }
  return null;
};
